import { PublicKey } from "@solana/web3.js";

export const HOUSE_TREASURY = 'house_treasury';
export const HOUSE_STATE = 'house_state';
export const DEGENERATE = 'degenerate';
export const REWARDS = 'rewards';
export const DEGEN_COIN_FLIP = 'degen_coin_flip';
export const DEGEN_COIN_FLIP_PROGRAM_ID = new PublicKey(
  '3r2St9LGBnXMxv2msAZ4eGAPFNHwpNMbudkdBxdZCCRL',
);

export const INITIALIZER_ID = new PublicKey(
  'DAdbcE5SdqoQArf7V87pYR6jPNmTtEUbR2XeC1kAzZjh',
);

export const AUTHORITY_ID = new PublicKey(
  'B3tvcC35ehGUtLhb68K7YXyfn5pY8YbLttV3tsabTKvs',
);

export const FUNDS_ID = new PublicKey(
  `9ACFS2Ekes8y1tFPy2toMkdVCquJWMZ3XuESphppmf6E`
);

export const MEMO_ID = new PublicKey(
  "MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr"
);

export const PREORDER_ID = new PublicKey(
  "BgqG8xf2Mc23rckvMxBdShXRdVEqaWPC1KAqjoVsjP7J"
);

export const PREORDER_WALLET_ID = new PublicKey(
  "691eN2jwZuoEguHmauqEWa8Ady5haJiHQBLpwYH1Cqp8"
);

export const PREORDER_WALLET_DEV = new PublicKey(
  "819VSjbvCvp9YpnKJAe2NCGTzyFajf5fwhBm5uYvhfor"
);
